var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.862351,8.84671172 L6.82549106,0.467213563 C6.64971341,0.17463252 6.34110053,0 5.9998514,0 C5.65860228,0 5.3499894,0.17463252 5.17478432,0.466640997 L0.137351807,8.84671172 C-0.0412886726,9.14387328 -0.0458691977,9.51546839 0.124755363,9.81721048 C0.294807359,10.1189526 0.616016683,10.3061815 0.962991462,10.3061815 L11.0372839,10.3061815 C11.3836861,10.3061815 11.705468,10.1189526 11.87552,9.81721048 C12.0461446,9.51546839 12.0409915,9.14387328 11.862351,8.84671172 Z M6.28613422,8.58848461 L5.71356858,8.58848461 C5.55554047,8.58848461 5.42728576,8.46022991 5.42728576,8.30220179 L5.42728576,7.72963615 C5.42728576,7.57160803 5.55554047,7.44335333 5.71356858,7.44335333 L6.28613422,7.44335333 C6.44416234,7.44335333 6.57241705,7.57160803 6.57241705,7.72963615 L6.57241705,8.30220179 C6.57241705,8.46022991 6.44416234,8.58848461 6.28613422,8.58848461 Z M5.9998514,6.29822205 L5.9998514,6.29822205 C5.68379517,6.29822205 5.42728576,6.04171264 5.42728576,5.72565641 L5.42728576,4.00795949 C5.42728576,3.69190325 5.68379517,3.43539385 5.9998514,3.43539385 L5.9998514,3.43539385 C6.31590764,3.43539385 6.57241705,3.69190325 6.57241705,4.00795949 L6.57241705,5.72565641 C6.57241705,6.04171264 6.31590764,6.29822205 5.9998514,6.29822205 Z",
    id: "Shape-Copy",
    fill: "#BE366C",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/ICON_alert.1ff4863799a94c637666eba3ff169a94.svg";
export { ForwardRef as ReactComponent };